const initializeAbrirConta = () => {
  document.addEventListener('DOMContentLoaded', () => {
    // 👉 Abrir o modal
    const openModal = (modalId) => {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.body.classList.add('overflow-hidden');
        modal.classList.add('active');
      }
    };

    // 👉 Fechar o modal
    const closeModal = () => {
      const modal = document.querySelector('.modal.active');
      if (modal) {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.classList.remove('overflow-hidden');
        modal.classList.remove('active');
      }
    };

    // 👉 Abrir modal
    const btnsOpenModal = document.querySelectorAll('[data-modal-target]');
    btnsOpenModal.forEach(btn => {
      const modalTarget = btn.getAttribute('data-modal-target');
      btn.addEventListener('click', () => openModal(modalTarget));
    });

    // 👉 Fechar modal (botões de fechar)
   document.querySelectorAll('.btn-fechar-modal-conta').forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = btn.closest('.modal');
        closeModal(modal);
      });
    });


    // 👉 Fechar clicando fora do conteúdo
    const modalBackground = document.querySelectorAll('.modal');
    modalBackground.forEach(modal => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });
    });

    // 👉 Fechar com tecla Esc
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    // 👉 Seleção dos cards com borda e sombra
    const cardLabels = document.querySelectorAll('label[data-tipo-conta]');

    cardLabels.forEach(label => {
      label.addEventListener('click', () => {
        // Remove borda e sombra de todos
        cardLabels.forEach(l => {
          l.style.border = '1px solid transparent';
          l.style.borderRadius = '24px';
          l.style.boxShadow = 'none';
        });

        // Adiciona ao selecionado
        label.style.border = '1px solid rgba(156, 123, 58, 1)';
        label.style.borderRadius = '24px';
        label.style.boxShadow = '0 0 0 3px rgba(156, 123, 58, 0.2)';

        // Marca o input interno como checked
        const input = label.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
        }
      });
    });

    // 👉 Botão avançar
    const btnAvancar = document.getElementById('btn-avancar');
    if (btnAvancar) {
      btnAvancar.addEventListener('click', () => {
        const tipoSelecionado = document.querySelector('input[name="tipo-conta"]:checked');
        if (tipoSelecionado) {
          const tipo = tipoSelecionado.value;
          const urlDestino = tipo === 'fisica'
            ? 'https://cadastro.xpi.com.br/v3/cadastro/nome?cb=1.1&assessor=A40672'
            : 'https://cadastro.xpempresas.com.br/cadastro/desktop/dados-pessoais/?cb=1.1&assessor=A40672';
          window.open(urlDestino, '_blank');
        } else {
          alert('Selecione uma opção para continuar.');
        }
      });
    }
  });
};

export default initializeAbrirConta;
